<div class="modal-content">
    <h2>{{ title }}</h2>
    <p>{{ content }}</p>
    <app-button (onClick)="onConfirm.emit()">{{ confirm }}</app-button>
    <app-button type="danger" (onClick)="closeModal()">{{ cancel }}</app-button>
</div>